import { T } from '@tf/utils';

export const getLinkedObjectIdFromMutationResult = (
	result: Record<'mutate', any>,
	objectId: string,
	relationKind: string,
): string => {
	const object = result.mutate.find((o: { id: string }) => o.id === objectId);
	const linkedObjectId = object?.meta?.[relationKind][0];
	T.assertNotNullish(linkedObjectId, `could not find ${relationKind} object for ${objectId} in mutation result`);
	return linkedObjectId;
};
